import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { PromptSuggestions } from "models/interfaces/conversations/prompt-suggestions/prompt-suggestions";
import NotebookPromptSuggestionsRecord from "./notebook-prompt-suggestion-record";
import PromptSuggestionRecord from "./prompt-suggestion-record";

const defaultValues: PromptSuggestions = {
    notebooks: new NotebookPromptSuggestionsRecord(),
    bookview: [],
    global: [],
};

export default class PromptSuggestionsRecord
    extends Record(defaultValues)
    implements PromptSuggestions
{
    constructor(params?: Partial<PromptSuggestions>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.notebooks != null) {
            RecordUtils.ensureRecord(
                params.notebooks,
                NotebookPromptSuggestionsRecord
            );
        }

        if (params.bookview != null) {
            RecordUtils.ensureRecords(params.bookview, PromptSuggestionRecord);
        }

        if (params.global != null) {
            RecordUtils.ensureRecords(params.global, PromptSuggestionRecord);
        }

        super(params);
    }
}
